import AuditLogsPage from '@/features/system/audit/pages/audit-logs-page'
import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/activity/')({
  component: AuditLogsPage,
  beforeLoad: requireRole(['admin']),
})
